import { useDispatch, useSelector } from "react-redux"
import { getInterest, getJourney } from "reducers/userInfo"
import { getHasPartnerInfo, getInterestIsFertility } from "derivedSelectors"
import { updateInterestAndJourney, updateJourney } from "actions/userActions"
import { GetJourneyChoicesAndNextSteps } from "components/views/fle/journey/GetJourneyChoicesAndNextSteps"
import { Button } from "components/views/atoms/buttons/Button"
import { FleLayout } from "components/views/fle/FleLayout"
import { TopSection } from "components/views/fle/TopSection"
import { BackArrow, SkipArrow, SwitchH2ToBodyLarge } from "components/views/fle/Molecules"
import { Spacer } from "components/views/atoms/Atoms"
import { FleLinkWrapper } from "components/views/atoms/Links"
import React from "react"
import L10n from "lib/carrot-l10n"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const JourneyWhereAreYou = ({ skip, history }) => {
  const benefitConfiguration = useSelector(getBenefitConfiguration)
  const { interest, journey, interestIsFertility, hasPartner } = useSelector((state) => ({
    journey: getJourney(state),
    interest: getInterest(state),
    hasPartner: getHasPartnerInfo(state),
    interestIsFertility: getInterestIsFertility(state)
  }))
  const dispatch = useDispatch()

  const submitJourney = async ({ interest, journey, next }) => {
    if (interest) {
      await dispatch(updateInterestAndJourney({ interest, journey }, null))
    } else {
      await dispatch(updateJourney(journey, null))
    }
    history.push(next) //Route to the correct next page
  }

  const journeyChoiceButtons = GetJourneyChoicesAndNextSteps().map((journeyChoice) => {
    const { singular, plural } = journeyChoice.pronouns
    const pronoun = hasPartner ? plural : singular

    const filter = journeyChoice.filter
    if (filter && !filter(benefitConfiguration)) {
      return null
    }

    return (
      <div key={journeyChoice.id} className="flex flex-row justify-end w-100 mb1">
        <Button bold={false} onClick={() => submitJourney(journeyChoice)}>
          {l(journeyChoice.labelKey, { pronoun })}
        </Button>
      </div>
    )
  })

  return (
    <FleLayout>
      <TopSection progressStep={4} leftOrBackArrow={<BackArrow />} />
      <SwitchH2ToBodyLarge>Where are you on your journey?</SwitchH2ToBodyLarge>
      <Spacer height={2} />
      {journeyChoiceButtons}
      <FleLinkWrapper>
        <SkipArrow to={skip} />
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { JourneyWhereAreYou }
